import { SetGetKyc } from './thunk/setGetKyc'
import {SetPostKyc} from './thunk/setPostKyc';

export const Thunks = {
    SetGetKyc,
    SetPostKyc
}